import isUndefined from 'lodash/isUndefined';
import omitBy from 'lodash/omitBy';
import { createAction } from 'typesafe-actions';

import { SearchActions, SearchKeys } from './constants';
import * as D from './deps';

interface SearchTermUpdateParams {
  searchFilter: $TSFixMe;
  searchTerm: $TSFixMe;
  searchType: $TSFixMe;
}
export const searchTermUpdate = createAction(
  D.ApiActions.T3_SEARCH_TERM_UPDATE,
  (params: SearchTermUpdateParams) => params,
)<SearchTermUpdateParams>();
export type SearchTermUpdateAction = ReturnType<typeof searchTermUpdate>;

interface SearchUIStateUpdateParams {
  active: $TSFixMe;
  componentName: $TSFixMe;
  hasFocus: $TSFixMe;
  isFocusEvent: $TSFixMe;
  searchType: $TSFixMe;
}
type SearchUIStateUpdatePayload = Pick<SearchTermUpdateParams, 'searchType'> &
  Partial<SearchUIStateUpdateParams>;

export const searchUIStateUpdate = createAction(
  SearchActions.SEARCH_UI_UPDATE,
  ({ hasFocus, active, searchType, isFocusEvent, componentName }: SearchUIStateUpdateParams) => {
    const content = {
      hasFocus,
      [SearchKeys.IS_FOCUS_EVENT]: isFocusEvent,
      [SearchKeys.SEARCH_ACTIVE]: active,
      componentName,
    };
    // Only pass along content without undefined values
    return {
      ...omitBy(content, isUndefined),
      searchType,
    };
  },
)<SearchUIStateUpdatePayload>();

export type SearchUIStateUpdateAction = ReturnType<typeof searchUIStateUpdate>;

interface SearchItemSelectParams {
  componentName: $TSFixMe;
  id: $TSFixMe;
  isPlayAction: $TSFixMe;
  listIndex: $TSFixMe;
  resultAction: $TSFixMe;
  results: $TSFixMe;
  searchFilter: $TSFixMe;
  searchTerm: $TSFixMe;
  stationCode: $TSFixMe;
}
export const searchItemSelect = createAction(
  SearchActions.SEARCH_SELECT,
  (params: SearchItemSelectParams) => params,
)<SearchItemSelectParams>();
export type SearchItemSelectAction = ReturnType<typeof searchItemSelect>;

export const searchCleared = createAction(SearchActions.SEARCH_CLEAR)();
export type SearchClearedAction = ReturnType<typeof searchCleared>;

interface SearchResultsScrollParams {
  componentName: $TSFixMe;
  results: $TSFixMe;
  searchFilter: $TSFixMe;
  searchTerm: $TSFixMe;
}
export const searchResultsScroll = createAction(
  SearchActions.SEARCH_SCROLL,
  (params: SearchResultsScrollParams) => params,
)<SearchResultsScrollParams>();
export type SearchResultsScrollAction = ReturnType<typeof searchResultsScroll>;

interface SearchResultsRenderedParams {
  searchFilter: $TSFixMe;
  searchTerm: $TSFixMe;
}
export const searchResultsRendered = createAction(
  SearchActions.SEARCH_RESULTS_RENDERED,
  (params: SearchResultsRenderedParams) => params,
)<SearchResultsRenderedParams>();
export type SearchResultsRenderedAction = ReturnType<typeof searchResultsRendered>;

interface FullSearchParams {
  pageSize: number | $TSFixMe;
  searchFilter: string | $TSFixMe;
  searchTerm: $TSFixMe;
  searchTime: number | $TSFixMe;
  searchType: $TSFixMe;
  startIndex: number | $TSFixMe;
}
type FullSearchPayload = Omit<FullSearchParams, 'startIndex' | 'pageSize'> & {
  count: FullSearchParams['pageSize'];
  start: FullSearchParams['startIndex'];
};

export const fullSearch = createAction(
  SearchActions.FULL_SEARCH,
  ({
    searchTerm,
    searchFilter = 'all',
    searchType,
    startIndex = 0,
    pageSize = 50,
    searchTime = 0,
  }: FullSearchParams) => ({
    searchTerm,
    searchType,
    searchFilter,
    searchTime,
    start: startIndex,
    count: pageSize,
  }),
)<FullSearchPayload>();

export type FullSearchAction = ReturnType<typeof fullSearch>;

export const resetResults = createAction(SearchActions.RESET_RESULTS)();
export type ResetResultsAction = ReturnType<typeof resetResults>;

interface FilterChangedParams {
  results: $TSFixMe;
  searchFilter: $TSFixMe;
  searchTerm: $TSFixMe;
}
export const filterChanged = createAction(
  SearchActions.FILTER_CHANGED,
  (params: FilterChangedParams) => params,
)<FilterChangedParams>();
export type FilterChangedAction = ReturnType<typeof filterChanged>;

export const closeSearch = createAction(SearchActions.CLOSE_SEARCH)();
export type CloseSearchAction = ReturnType<typeof closeSearch>;
